<template>
    <div class="item-box" @click="openService">
        <h1> {{ service.name }} </h1>
        <button class="action-button" @click="takeAction()" v-if="service.actionable == true">W</button>
        <h2 v-else>{{ service.latestData.value}} {{ service.unit }}</h2>
    </div>
</template>

<script>
    export default {
        props: {
            service: {
                name: '',
                latestData: {
                    value: '',
                    time: ''
                },
                unit: '',
                actions: {
                    watering: "watering"
                },
                actionable: false
            }
        },
        methods: {
            takeAction() {
                console.log("Action taken!", this.service.name )
            },
            openService() {
                let tilePath = 'tiles/' + this.service.ref.parent.parent.id
                this.$router.push({ path: tilePath, query: { service: this.service.id } })
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/ItemBox.vue